/* Lucebox shop behavior: header, reveal, shipping ETA, gallery, edition picker. No dependencies. */
(function () {
  'use strict';

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function initHeader() {
    var header = document.querySelector('[data-lb-header]');
    if (!header) return;
    var nav = header.querySelector('[data-lb-nav]');
    if (!nav) return;

    function onScroll() { nav.classList.toggle('is-scrolled', window.scrollY > 24); }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initReveal() {
    var nodes = document.querySelectorAll('.lb-reveal');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (node) { node.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    nodes.forEach(function (node) { observer.observe(node); });
  }

  function initGallery(root) {
    var slides = root.querySelectorAll('[data-lb-gallery-slide]');
    var thumbs = root.querySelectorAll('[data-lb-gallery-thumb]');
    var counter = root.querySelector('[data-lb-gallery-index]');
    var strip = root.querySelector('.lb-gallery__thumbs');
    if (slides.length < 2) return;

    /* Keeps the active thumb visible when the strip scrolls; moves the strip only, never the page. */
    function revealThumb(thumb) {
      if (!strip || !thumb || strip.scrollWidth <= strip.clientWidth) return;
      var target = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    var index = 0;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.hidden = i !== index; });
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(index + 1).padStart(2, '0');
      revealThumb(thumbs[index]);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(Number(thumb.getAttribute('data-lb-gallery-thumb'))); });
    });

    var prev = root.querySelector('[data-lb-gallery-prev]');
    var next = root.querySelector('[data-lb-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    /* Arrow keys move the gallery when it has focus. */
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
  }

  /* Buy panel: edition choice swaps price, checkout variant and the Talk to us state. */
  function initBuyPanel(root) {
    var radios = root.querySelectorAll('[data-lb-edition]');
    var price = root.querySelector('[data-lb-price]');
    var variantInput = root.querySelector('[data-lb-variant-id]');
    var form = root.querySelector('form.lb-buy__form');
    var contact = root.querySelector('[data-lb-contact]');
    var payButton = root.querySelector('.lb-buy__pay');
    var payLabel = (payButton && payButton.getAttribute('data-label')) || 'Order now';
    var dockPrice = root.querySelector('[data-lb-dock-price]');

    function apply(radio) {
      if (price) price.textContent = radio.getAttribute('data-price');
      if (dockPrice) dockPrice.textContent = radio.getAttribute('data-price');
      if (variantInput) variantInput.value = radio.value;

      var isContact = radio.getAttribute('data-contact') === 'true';
      if (form) form.hidden = isContact;
      if (contact) contact.hidden = !isContact;

      if (payButton) {
        var available = radio.getAttribute('data-available') === 'true';
        payButton.disabled = !available;
        payButton.querySelector('span').textContent = available ? payLabel : 'Sold out';
      }

      /* The URL stays clean: the edition travels in the form, not in a query parameter. */
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { if (radio.checked) apply(radio); });
      if (radio.checked) apply(radio);
    });

    /* The buy button empties the cart before adding, so clicking it twice cannot order two machines.
       The plain form post only ever appends, which is how a test run ended up with five. */
    if (payButton && form && window.fetch) {
      payButton.addEventListener('click', function (event) {
        event.preventDefault();
        var quantityInput = form.querySelector('.lb-qty__input');
        if (!variantInput) { form.submit(); return; }

        var label = payButton.querySelector('span');
        payButton.disabled = true;
        if (label) label.textContent = 'One moment';

        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: variantInput.value,
                quantity: Number(quantityInput && quantityInput.value) || 1
              })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            /* Network trouble: fall back to the ordinary form post rather than dead-ending. */
            payButton.disabled = false;
            if (label) label.textContent = payLabel;
            form.submit();
          });
      });
    }

    root.querySelectorAll('[data-lb-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = root.querySelector('.lb-qty__input');
        if (!input) return;
        var next = (Number(input.value) || 1) + Number(button.getAttribute('data-lb-qty'));
        var min = Number(input.min) || 1;
        var max = Number(input.max) || 20;
        input.value = Math.min(max, Math.max(min, next));
      });
    });
  }

  /* Phones: the dock stands in for the buy button while that button is off screen. */
  function initDock(root) {
    var dock = root.querySelector('[data-lb-dock]');
    var dockButton = root.querySelector('[data-lb-dock-btn]');
    var payButton = root.querySelector('.lb-buy__pay');
    var form = root.querySelector('form.lb-buy__form');
    if (!dock || !dockButton || !payButton || !window.IntersectionObserver || !window.matchMedia) return;

    var phone = window.matchMedia('(max-width: 720px)');
    var payVisible = true;

    function cookieBannerUp() {
      var banner = document.getElementById('shopify-pc__banner');
      /* The banner is position: fixed, so offsetParent is always null; ask for its boxes instead. */
      return !!(banner && banner.getClientRects().length > 0 && getComputedStyle(banner).display !== 'none');
    }

    function update() {
      var show = phone.matches && !payVisible && !(form && form.hidden) && !payButton.disabled && !cookieBannerUp();
      dock.hidden = !show;
      document.documentElement.classList.toggle('lb-dock-on', show);
    }

    new IntersectionObserver(function (entries) {
      payVisible = entries[0].isIntersecting;
      update();
    }).observe(payButton);

    dockButton.addEventListener('click', function () { payButton.click(); });
    root.addEventListener('change', update);
    document.addEventListener('visitorConsentCollected', function () { setTimeout(update, 50); });
    window.addEventListener('scroll', update, { passive: true });
    if (phone.addEventListener) phone.addEventListener('change', update);
    update();
  }

  // Footer "Cookie settings" reopens Shopify's consent preferences, like the lucebox.com footer.
  // The button hides itself where Shopify has not loaded its privacy banner.
  function initCookieSettings(button) {
    var banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') {
      button.hidden = true;
      return;
    }
    button.addEventListener('click', function () {
      banner.showPreferences();
    });
  }

  function init() {
    document.documentElement.classList.add('lb-has-js');
    initHeader();
    initReveal();
    document.querySelectorAll('[data-lb-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-lb-buy]').forEach(initBuyPanel);
    document.querySelectorAll('.lb-buy').forEach(initDock);
    document.querySelectorAll('[data-lb-cookie-settings]').forEach(initCookieSettings);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
